import React from 'react';
import './Carousel.css';
import pic1 from '../assets/img/carousel/1.jpg';
import pic2 from '../assets/img/carousel/2.jpg';
import pic3 from '../assets/img/carousel/3.jpg';

class Carousel extends React.Component {
  constructor() {
    super();

    this.carouselImages = [
      {
        url: pic1,
        h2: 'Gabinet przyjazny dzieciom',
        h3: 'W trosce o małe stópki, zapewniamy miłą atmosferę oraz odpowiednie podejście pedagogiczne.'
      },
      {
        url: pic2,
        h2: 'Stali klienci mają się lepiej',
        h3: 'Zapytaj o to jak zostać stałym klientem i korzystaj z rabatów oraz eksluzywnych ofert'
      },
      {
        url: pic3,
        h2: 'Gabinet przyjazny ekologii',
        h3: 'Skorzystaj z dobrodziejstwa wegańskich produktów pielęgnacyjnych renomowanej firmy. Doskonałe uzupełnienie Twoich zabiegów podologicznych.'
      }
    ]

    this.state = {
      currentPicUrl: this.carouselImages[0].url,
      currentPicIndex: 0,
      currentTextH2: this.carouselImages[0].h2,
      currentTextH3: this.carouselImages[0].h3
    }

    this.imageChanger = this.imageChanger.bind(this);
  }

  imageChanger() {
    if (this.state.currentPicIndex < 2) {
      this.setState({
        currentPicIndex: this.state.currentPicIndex + 1,
        currentPicUrl: this.carouselImages[this.state.currentPicIndex].url,
        currentTextH2: this.carouselImages[this.state.currentPicIndex].h2,
        currentTextH3: this.carouselImages[this.state.currentPicIndex].h3,
      })
    } else {
      this.setState({
        currentPicIndex: 0,
        currentPicUrl: this.carouselImages[this.state.currentPicIndex].url,
        currentTextH2: this.carouselImages[this.state.currentPicIndex].h2,
        currentTextH3: this.carouselImages[this.state.currentPicIndex].h3,
      })
    }
  }

  componentDidMount() {
    setInterval(this.imageChanger, 3000);
  }

  render() {
    return (
      <section className="carousel" style={{backgroundImage: `url('${this.state.currentPicUrl}')`}}>
        <div className="carousel-shadow">
          <div className="carousel-text">
            <div className="container">
              <h2>{this.state.currentTextH2}</h2>
              <h3>{this.state.currentTextH3}</h3>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Carousel;
